/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { MDCRipple, MDCRippleFoundation } from '@material/ripple';
export class ForgeRipple extends MDCRipple {
}
export class ForgeRippleFoundation extends MDCRippleFoundation {
}
